
import Vue from 'vue';
import Component from 'vue-class-component';
import { Subscription } from 'rxjs';

import RappidService from 'src/services/rappid.service';
import JsonEditor from 'src/components/Chatbot/Json-editor/Json-editor.vue';
import Inspector from 'src/components/Chatbot/Inspector/Inspector.vue';
import { STENCIL_WIDTH } from 'src/theme';
import { SharedEvents } from 'src/rappid/controller';
import { importGraphFromJSON, loadStencilShapes, zoomToFit } from 'src/rappid/actions';

import exampleGraphJSON from 'src/rappid/config/example-graph.json';

@Component({
    components: {
        Inspector,
        JsonEditor
    }
})
export default class Chatbot extends Vue {

    public rappid = null as RappidService;
    public stencilOpened = true;
    public jsonEditorOpened = true;
    public fileJSON = {};

    private subscriptions = new Subscription();

    public mounted(): void {
        const { $el, $refs: { paper, stencil, toolbar }, subscriptions, $eventBusService } = this;
        subscriptions.add(
            $eventBusService.on(SharedEvents.GRAPH_CHANGED, (json: Object) => this.onRappidGraphChange(json))
        );
        subscriptions.add(
            $eventBusService.on(SharedEvents.JSON_EDITOR_CHANGED, (json: Object) => this.onJsonEditorChange(json))
        );

        this.rappid = new RappidService(
            $el,
            paper as Element,
            stencil as Element,
            toolbar as Element,
            $eventBusService
        );
        this.setStencilContainerSize();
        this.onStart();
    }

    public beforeDestroy(): void {
        this.subscriptions.unsubscribe();
        this.rappid.destroy();
    }

    public openFile(json: Object): void {
        const { rappid } = this;
        this.fileJSON = json;
        importGraphFromJSON(rappid, json);
        zoomToFit(rappid);
    }

    public toggleJsonEditor(): void {
        this.jsonEditorOpened = !this.jsonEditorOpened;
    }

    public toggleStencil(): void {
        this.stencilOpened = !this.stencilOpened;
        this.onStencilToggle();
    }

    private onStart(): void {
        const { rappid } = this;
        loadStencilShapes(rappid);
        this.openFile(exampleGraphJSON);
    }

    private onJsonEditorChange(json: Object): void {
        const { rappid } = this;
        if (rappid) {
            importGraphFromJSON(rappid, json);
        }
    }

    private onRappidGraphChange(json: Object): void {
        this.fileJSON = json;
    }

    private setStencilContainerSize(): void {
        (this.$refs.stencil as HTMLDivElement).style.width = `${STENCIL_WIDTH}px`;
        this.onStencilToggle();
    }

    private onStencilToggle(): void {
        const { rappid, stencilOpened } = this;
        const { scroller, stencil } = rappid;
        if (stencilOpened) {
            stencil.unfreeze();
            scroller.el.scrollLeft += STENCIL_WIDTH;
        } else {
            stencil.freeze();
            scroller.el.scrollLeft -= STENCIL_WIDTH;
        }
    }
}
